/* eslint-disable max-len */
// @flow
export const IS_DEVEL = process.env.NODE_ENV !== 'production';

export const SHARE_CONSTANTS = {
	FACEBOOK: 'Facebook',
	WHATSAPP: 'WhatsApp',
	TWITTER: 'Twitter',
	MAIL: 'Mail',
};

export const SHARES_POSITION = {
	HEADER: 'Header',
	CONTENT: 'Content',
	FOOTER: 'Footer',
};

export const EVENT_TYPES = {
	MATCH_STATUS: 'MatchStatus',
	IMAGE: 'תמונה',
	JUDGES_DECISION: 'החלטת שופט',
	JUDGES_DECISION_V2: 'החלטת השופט',
	INJURY: 'פציעה',
	YELLOW_CARD: 'כרטיס צהוב',
	SECOND_YELLOW_CARD: 'כרטיס צהוב שני',
	RED_CARD: 'כרטיס אדום',
	GOAL: 'שער',
	OWN_GOAL: 'שער עצמי',
	MISSED_THE_GATE: 'החמצה',
	SUBSTITUTION: 'חילוף',
	PENALTY_GOAL: 'שער בפנדל',
	MISSED_THE_GATE_FROM_PENALTY: 'החמצת פנדל',
	OTHER: 'אחר', // STAR
	OFFSIDE: 'נבדל',
};

export const PART_TITLES = {
	FIRST_PART: 'מחצית ראשונה',
	SECOND_PART: 'מחצית שניה',
	PENALTIES: 'פנדלים',
	EXTRA_TIME: '',
};
